import { render } from "./video-intro.vue?vue&type=template&id=5702a49e"
import script from "./video-intro.vue?vue&type=script&lang=ts"
export * from "./video-intro.vue?vue&type=script&lang=ts"

import "./video-intro.vue?vue&type=style&index=0&id=5702a49e&lang=scss"
script.render = render

export default script